module.exports = __webpack_public_path__ + "img/Weapon_41.a83a8fca.png";